import Vue from "vue";
import Router from "vue-router";
import CustomerRouterContainer from "@/containers/CustomerRouterContainer";
import HomeRouterContainer from "@/containers/HomeRouterContainer";
import HomePage from "@/containers/HomePage";
import Dashboard from "@/containers/Dashboard/Dashboard";
import Settings from "@/containers/Config/Settings";
import Login from "@/containers/Login";
import CustomerProfile from "@/containers/Customer/CustomerProfile";
import CustomerDevices from "@/containers/Customer/Devices";
import CustomerRequests from "@/containers/Customer/Requests";
import OrderWidget from "@/containers/Customer/OrderWidget/OrderWidget.vue";
import CustomerHistory from "@/containers/Customer/History";
import DevicesPage from "@/containers/Customer/Devices/DevicesPage";
import DeviceDetails from "@/containers/Customer/Devices/DeviceDetails";
import Profile from "@/containers/Profile";
import Event from "@/containers/Customer/Events/Event";
import FeatureRequests from "@/containers/FeatureRequests/FeatureRequests";
import JWTDecode from "jwt-decode";
import browserLocation from "@/helpers/BrowserLocation";

import store from "@/modules";
import { isEmpty } from "lodash";

Vue.use(Router);

const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { requiresAuth: false },
    children: [
      {
        path: ":token",
        component: Login,
      },
    ],
  },
  {
    path: "/",
    component: HomeRouterContainer,
    children: [
      {
        path: "",
        name: "HomePage",
        component: HomePage,
        meta: { requiresAuth: true },
      },
      {
        path: "profile",
        name: "profile",
        component: Profile,
        meta: { requiresAuth: true },
      },
      {
        path: "settings",
        name: "settings",
        component: Settings,
        meta: { requiresAuth: true },
      },
      {
        path: "feature-requests",
        name: "FeatureRequests",
        component: FeatureRequests,
        meta: { requiresAuth: true },
      },
      {
        path: "orders",
        name: "OrderWidget",
        component: OrderWidget,
        meta: { requiresAuth: true, title: "requests" },
        children: [],
      },
    ],
  },
  {
    path: "/customer/:customer_id",
    component: CustomerRouterContainer,
    meta: { requiresAuth: true, requiresCustomer: true },
    children: [
      {
        path: "",
        name: "CustomerProfile",
        component: CustomerProfile,
        meta: {
          requiresAuth: true,
          requiresCustomer: true,
          title: "account",
          includes: ["account_admin_tags", "account_robin_tags"],
        },
        children: [],
      },
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
          requiresCustomer: true,
          title: "dashboard",
          includes: [],
        },
      },
      {
        path: "devices",
        component: CustomerDevices,
        meta: { requiresAuth: true, requiresCustomer: true, title: "devices" },
        children: [
          {
            path: "",
            name: "Devices",
            component: DevicesPage,
            meta: {
              requiresAuth: true,
              requiresCustomer: true,
              title: "devices",
            },
          },
          {
            path: ":doorbot_id",
            name: "Device",
            component: DeviceDetails,
            meta: {
              requiresAuth: true,
              requiresCustomer: true,
              title: "device",
            },
          },
        ],
      },
      {
        path: "requests",
        name: "CustomerRequests",
        component: CustomerRequests,
        meta: { requiresAuth: true, requiresCustomer: true, title: "requests" },
        children: [],
      },
      {
        path: "orders",
        name: "OrderWidget",
        component: OrderWidget,
        meta: { requiresAuth: true, requiresCustomer: true, title: "requests" },
        children: [],
      },
      {
        path: "history",
        name: "CustomerHistory",
        component: CustomerHistory,
        meta: { requiresAuth: true, requiresCustomer: true, title: "history" },
        children: [],
      },
      {
        path: "events/:id",
        name: "Event",
        component: Event,
        meta: { requiresAuth: true, requiresCustomer: true, title: "history" },
        children: [],
      },
    ],
  },
  { path: "*", redirect: { name: "HomePage" } },
];

const router = new Router({ routes, mode: "history" });

let fetchMasterData = (next) => {
  let products = store.getters["shared/reasons"];
  let reasons = store.getters["shared/products"];
  if (isEmpty(reasons) || isEmpty(products)) {
    store
      .dispatch("shared/fetchMasterData", {}, { root: true })
      .then(() => next())
      .catch(() => next());
  } else next();
};

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    let token = localStorage.getItem("@token_id") || "";
    let data;
    if (to.name !== "Login") {
      browserLocation.setTargetUrl(`${location.origin}${to.fullPath}`);
    }
    try {
      data = JWTDecode(token);
    } catch (error) {
      return next({ name: "Login" });
    }
    let now = new Date();
    if (token) {
      const exp_ts = Number(data.exp) * 1000;
      if (exp_ts >= now.getTime()) {
        next();
      } else {
        return next({ name: "Login" });
      }
    } else {
      return next({ name: "Login" });
    }
  } else {
    next();
  }

  const isNavigatingWithinApp = router.history.current !== from;

  if (isNavigatingWithinApp) {
    // ignore
  } else {
    // Direct navigation via URL
    store.dispatch("shared/fetchMasterData", {}, { root: true });
  }

  if (to.meta.requiresCustomer) {
    try {
      let keep_previous_data = false;
      try {
        keep_previous_data =
          store.getters["db/account/customerId"] === to.params.customer_id;
      } catch (error) {}

      store
        .dispatch(
          "db/account/globalSearch",
          {
            criteria: to.params.customer_id,
            model: "Customer",
            includes: [],
            keep_previous_data,
          },
          { root: true }
        )
        .catch(() => {
          if (from.name === null) {
            setTimeout(() => {
              vm.$notify.warning({
                title: "Customer not found",
                message: "Error",
                duration: 0,
              });
            }, 1000);
            return next((vm) => vm.$router.push({ name: "HomePage" }));
          }
        });
    } catch (e) {
      next(false);
      return e.data.message;
    }
  }
});

export default router;
